// src/services/authService.js
import api from './api';

const authService = {
  saveSession: ({ token, user }) => {
    if (token) localStorage.setItem('token', token);
    if (user) localStorage.setItem('user', JSON.stringify(user));
  },

  // Login
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  verifyMfaLogin: async (mfaToken, code) => {
    const response = await api.post('/auth/mfa/verify-login', { mfa_token: mfaToken, code });
    return response.data;
  },

  startMfaSetup: async (mfaToken, password) => {
    const response = await api.post(
      '/auth/mfa/setup',
      password ? { password } : {},
      { headers: { Authorization: `Bearer ${mfaToken}` } }
    );
    return response.data;
  },

  verifyMfaSetup: async (mfaToken, code) => {
    const response = await api.post(
      '/auth/mfa/setup/verify',
      { code },
      { headers: { Authorization: `Bearer ${mfaToken}` } }
    );
    return response.data;
  },

  // Register
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Logout
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Error al hacer logout:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data.user;
  },

  // Get token from localStorage
  getToken: () => {
    return localStorage.getItem('token');
  },

  // Get user from localStorage
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
};

export default authService;
